import { render, staticRenderFns } from "./PersonnalConfigAy.vue?vue&type=template&id=04e5e89e&scoped=true&"
import script from "./PersonnalConfigAy.vue?vue&type=script&lang=js&"
export * from "./PersonnalConfigAy.vue?vue&type=script&lang=js&"
import style0 from "./PersonnalConfigAy.vue?vue&type=style&index=0&id=04e5e89e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5e89e",
  null
  
)

component.options.__file = "PersonnalConfigAy.vue"
export default component.exports